// extracted by mini-css-extract-plugin
export default {"error":"error-message-module--error--46530","errorIcon":"error-message-module--error-icon--c78e7"};